import { useTranslation } from "react-i18next";
import {
  FileIcon,
  FileErrorIcon,
  TrashIcon,
  UploadCloudIcon,
  CheckCircleOutlineIcon,
} from "../../assets/svgs";
import { FILE_UPLOAD_STATUS } from "../../constants";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const FileUploadCard = ({ onClickTryAgain }) => {
  const { t } = useTranslation();
  const {
    fileUploadStatus,
    fileUploadDetails,
    fileUploadProgress,
    handleSetFileUploadProgress,
    handleSetFileUploadStatus,
    handleSetFileUploadDetails,
    handleFileSelect,
  } = useApp();

  const handleOnClickTryAgain = () => {
    handleSetFileUploadProgress(1);
    handleSetFileUploadStatus(FILE_UPLOAD_STATUS.UPLOADING);
    onClickTryAgain({
      file: fileUploadDetails.file,
      base64: fileUploadDetails.base64,
      type: fileUploadDetails.type,
    });
  };

  const handleOnClickDelete = () => {
    handleSetFileUploadStatus(FILE_UPLOAD_STATUS.NOT_STARTED);
    handleSetFileUploadProgress(0);
    handleSetFileUploadDetails({});
    handleFileSelect(null);
  };

  if (fileUploadStatus === FILE_UPLOAD_STATUS.NOT_STARTED) return null;

  return (
    <div
      className="file-upload-card-container"
      style={{
        border:
          fileUploadStatus === FILE_UPLOAD_STATUS.FAILED
            ? "2px solid var(--bs-danger-500)"
            : "1px solid #e3e8ef",
      }}
    >
      <div className="file-upload-card-content">
        <img
          src={
            fileUploadStatus === FILE_UPLOAD_STATUS.FAILED
              ? FileErrorIcon
              : FileIcon
          }
          alt="file icon"
          className="file-icon"
        />
        <div>
          <p className="file-name">{fileUploadDetails?.name}</p>
          {fileUploadStatus === FILE_UPLOAD_STATUS.FAILED ? (
            <>
              <p className="file-error">
                {t("company-details.file_upload_error")}
              </p>
              <p onClick={handleOnClickTryAgain} className="try-again">
                {t("global.try_again")}
              </p>
            </>
          ) : (
            <div className="file-details-container">
              <p className="file-size">{fileUploadDetails?.size}</p>
              <div className="file-details-separator" />
              <div className="file-progress-container">
                <img
                  src={
                    fileUploadStatus === FILE_UPLOAD_STATUS.COMPLETED
                      ? CheckCircleOutlineIcon
                      : UploadCloudIcon
                  }
                  alt="upload cloud icon"
                  className="upload-cloud-icon"
                />
                <p className="file-progress">{`${fileUploadProgress}%`}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <img
        src={TrashIcon}
        alt="trash icon"
        onClick={handleOnClickDelete}
        className="trash-icon"
      />
    </div>
  );
};

export default FileUploadCard;
